import { Pipe, PipeTransform } from '@angular/core';
import { ITableColumn } from '@shared/types/common.types';

@Pipe({
  name: 'getColumn',
})
export class GetColumnPipe implements PipeTransform {
  transform<T>(columns: ITableColumn<T>[], prop: string): ITableColumn<T> {
    const result = columns.find((col) => col.propName === prop);
    return result || { propName: '' };
  }
}
